/* Экраны мини-приложения вокруг самих механик */

.screen {
  display: flex;
  flex-direction: column;
  gap: var(--mnk-space-4);
  padding: var(--mnk-space-4);
  padding-top: calc(var(--mnk-space-4) + env(safe-area-inset-top, 0px));
  padding-bottom: calc(var(--mnk-space-6) + env(safe-area-inset-bottom, 0px));
  max-width: 560px;
  margin: 0 auto;
  width: 100%;
}

.center {
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--mnk-space-3);
  padding: var(--mnk-space-5);
  text-align: center;
  color: var(--mnk-text-muted);
}

.errorText {
  color: var(--mnk-danger);
}

.points {
  display: inline-flex;
  align-items: center;
  gap: var(--mnk-space-2);
  font-family: var(--mnk-font-mono);
  font-size: var(--mnk-text-lg);
}

.chapterBlock {
  display: flex;
  flex-direction: column;
  gap: var(--mnk-space-3);
}

.chapterMeta {
  margin-top: var(--mnk-space-2);
}

.levels {
  display: flex;
  flex-direction: column;
  gap: var(--mnk-space-2);
}

.bottomActions {
  display: flex;
  gap: var(--mnk-space-3);
  margin-top: var(--mnk-space-2);
}

.topBar,
.levelBar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--mnk-space-2);
  padding: var(--mnk-space-2) var(--mnk-space-3);
  padding-top: calc(var(--mnk-space-2) + env(safe-area-inset-top, 0px));
}

.levelBar {
  background: rgba(5, 7, 11, 0.85);
  border-bottom: 1px solid var(--mnk-border);
  gap: var(--mnk-space-3);
}

.levelTitle {
  font-family: var(--mnk-font-display);
  font-size: var(--mnk-text-lg);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  text-align: center;
}

.levelBarRight {
  display: inline-flex;
  align-items: center;
  gap: var(--mnk-space-2);
}

/* Экран уровня: панель сверху, сцена во весь остаток, кнопки поверх */
.levelRoot {
  position: fixed;
  inset: 0;
  display: grid;
  grid-template-rows: auto 1fr;
  background: #05070b;
}

.skipIntro {
  position: absolute;
  right: var(--mnk-space-3);
  bottom: calc(var(--mnk-space-4) + env(safe-area-inset-bottom, 0px));
  z-index: 40;
  padding: var(--mnk-space-3) var(--mnk-space-4);
  border-radius: var(--mnk-radius-pill);
  border: 1px solid var(--mnk-border);
  background: rgba(5, 8, 12, 0.72);
  color: var(--mnk-text-muted);
  font-size: var(--mnk-text-md);
  cursor: pointer;
  backdrop-filter: blur(3px);
}

.skipIntro:active {
  transform: translateY(1px);
}

.overlay {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  background: rgba(2, 5, 10, 0.86);
  backdrop-filter: blur(4px);
  z-index: 60;
  padding: var(--mnk-space-4);
}

.overlayCard {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--mnk-space-3);
  text-align: center;
  background: var(--mnk-bg-elevated);
  border: 1px solid var(--mnk-border);
  border-radius: var(--mnk-radius-lg);
  padding: var(--mnk-space-6) var(--mnk-space-5);
  max-width: 420px;
  width: 100%;
  box-shadow: var(--mnk-shadow-lg);
}

.overlayCard h2 {
  margin: 0;
  font-family: var(--mnk-font-display);
}

.overlayText {
  margin: 0;
  color: var(--mnk-text-muted);
}

.overlayNote {
  margin: 0;
  color: var(--mnk-text-faint);
  font-size: var(--mnk-text-sm);
}

.link {
  display: block;
  padding: var(--mnk-space-3);
  border-radius: var(--mnk-radius-sm);
  background: var(--mnk-bg-sunken);
  font-family: var(--mnk-font-mono);
  font-size: var(--mnk-text-sm);
  word-break: break-all;
  color: var(--mnk-accent);
  margin-bottom: var(--mnk-space-3);
}

.rewardRow {
  display: flex;
  gap: var(--mnk-space-2);
  flex-wrap: wrap;
  margin-top: var(--mnk-space-3);
}

.note {
  color: var(--mnk-text-muted);
  font-size: var(--mnk-text-sm);
  margin: var(--mnk-space-3) 0 0;
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--mnk-space-2);
}

.listRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--mnk-space-3);
  padding: var(--mnk-space-2) 0;
  border-bottom: 1px solid var(--mnk-border);
}

.board {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--mnk-space-1);
}

.boardRow {
  display: grid;
  grid-template-columns: 28px 28px 1fr auto auto;
  align-items: center;
  gap: var(--mnk-space-3);
  padding: var(--mnk-space-2) var(--mnk-space-3);
  border-radius: var(--mnk-radius-md);
  background: var(--mnk-surface);
  border: 1px solid transparent;
}

.boardMe {
  border-color: var(--mnk-accent);
  background: var(--mnk-accent-soft);
}

.boardSticky {
  position: sticky;
  bottom: var(--mnk-space-3);
  margin-top: var(--mnk-space-3);
}

.rank {
  font-family: var(--mnk-font-mono);
  color: var(--mnk-text-faint);
  text-align: right;
}

.boardName {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.boardPoints {
  font-family: var(--mnk-font-mono);
  font-weight: 700;
}
